import React from 'react';
import './LoadingSpinner.css';

function LoadingSpinner({ text = "Loading..." }) {
  return (
    <div className="spinner-container">
      <div className="destination-spinner" role="status" aria-live="polite">
        <span className="spinner" aria-hidden="true"></span>
        <span className="loading-text">{text}</span>
      </div>
    </div>
  );
}

export default LoadingSpinner;
